module.exports = __webpack_public_path__ + "img/normal-bg.06229fc7.png";